<script>
import template from '../../views/partials/artworks/mosaic-tooltip.html';

export default {
  name: 'ArtworkMosaicTooltip',
  template,
  props: {
    artwork: {
      type: Object,
      required: true,
    },
    refs: {
      type: Object,
      required: true,
    },
  },
};
</script>
